<template>
  <el-table
    class="k-emails-table"
    :data="emails"
    style="width: 100%"
    :row-class-name="tableRowClassName"
  >
    <el-table-column
      prop="_id"
      label="ID"
      width="180">
    </el-table-column>

    <el-table-column
      prop="time"
      label="Created"
      width="180">
    </el-table-column>

    <el-table-column
      prop="email"
      label="E-Mail">
    </el-table-column>

    <el-table-column label="Actions" width="100">
      <template slot-scope="scope">
        <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" circle size="small"></el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
/**
 * Component: k-emails-table - Таблица для оторажения оредров
*
* @version 1.0.0
*/


export default {
  name: 'k-emails-table',

  props: {
    // Массив e-mail для отборажения в таблице
    emails: {
      type: Array,
      required: true,
    },
  },

  methods: {
    // Вычисляет класс для строки таблицы, что бы раскрасить ее
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
      return '';
    },

    // Удалени ордера
    handleDelete(email) {
      this.$emit('delete', email._id);
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-emails-table {
  $this: &;

  & .warning-row {
    background: oldlace;
  }

  & .success-row {
    background: #f0f9eb;
  }
}
</style>
